var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconHoverLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.724,
    viewBox: "0 0 18 15.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_605",
    "data-name": "Union 605",
    d: "M7.345,15.724a.724.724,0,0,1,0-1.448h3.31a.724.724,0,1,1,0,1.448ZM5.276,10.965a.724.724,0,0,1,0-1.448h7.448a.724.724,0,0,1,0,1.448ZM3,6.207A.724.724,0,1,1,3,4.759H15a.724.724,0,0,1,0,1.448ZM.724,1.448A.724.724,0,0,1,.724,0H17.276a.724.724,0,1,1,0,1.448Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconHoverLight);
export default __webpack_public_path__ + "static/media/filter-icon-hover-light.9c3b4bcb467f1a8b97bf4142dc5fba3b.svg";
export { ForwardRef as ReactComponent };